import "./nonce-init";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { FluentProvider, teamsLightTheme } from "@fluentui/react-components";
import { BrowserRouter } from "react-router-dom";
import { store, StoreContext } from "./stores/Stores";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
    <StoreContext.Provider value={store}>
        <FluentProvider theme={teamsLightTheme}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </FluentProvider>
    </StoreContext.Provider>
);
